import styled, { css } from 'styled-components';

import { ContainerType } from './types';

export const StyledThresholdTabContainer = styled.div<{
  lineNumberBarVisible: boolean;
}>`
  position: relative;
  width: 100%;
  height: auto;

  ${({ lineNumberBarVisible }) => lineNumberBarVisible && css`
    &:before {
      display: block;
      content: '';
      width: 26px;
      position: fixed;
      background: var(--cl-gray-100);
      height: 100%;
    }
  `}
`;

export const StyledRuleThresholdEditor = styled.div<{
  isDragging?: boolean;
}>`
  &&& {
    display: flex;
    align-items: flex-start;
    position: relative;
    flex-direction: column;
    box-sizing: content-box;
    font-family: var(--cl-font-family-mono);
    font-size: var(--cl-font-size-2);
    font-weight: var(--cl-font-weight-regular);
  
    ${({ isDragging }) => isDragging && css`
      cursor: grabbing !important;
    `}
  }
`;

export const StyledRuleLineContentWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledRuleThresholdContainer = styled.div<{
  simpleEditorMode: boolean;
  containerType: ContainerType;
}>`
  display: flex;
  align-items: flex-start;
  column-gap: 5px;
  position: relative;
  box-sizing: content-box;
  width: 100%;

  ${({ simpleEditorMode }) => simpleEditorMode && css`
    padding: 0 var(--cl-space-4) 0 0;
    width: calc(100% - var(--cl-space-4) -var(--cl-space-10));
  `}

  ${({ containerType }) => (
    containerType === ContainerType.TOOLTIP || containerType === ContainerType.MODAL
  ) && css`
    padding-left: 0;
    width: 100%;
  `}
`;

export const StyledRuleThresholdContentArea = styled.div<{
  containerType: ContainerType;
}>`
  width: 100%;
  padding-bottom: 7px;
`;

export const StyledRuleThresholdBottomArea = styled.div<{
  hasRules: boolean;
  containerType: ContainerType;
  simpleEditorMode: boolean;
}>`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: var(--cl-space-2);
  width: 100%;
  justify-content: space-between;
  position: relative;
  padding: ${({ hasRules }) => (hasRules
    ? '0 var(--cl-space-4) var(--cl-space-16) 38px'
    : 'var(--cl-space-4)')};
  ${({ containerType }) => containerType === ContainerType.MODAL && css`
    padding: 0 0 var(--cl-space-4) 0;
  `}
  ${({ simpleEditorMode }) => simpleEditorMode && css`
    padding: 0;
    gap: 0;
  `}
`;


export const StyledClauseWrapper = styled.div<{ isEmptyPreview?: boolean }>`
  align-items: center;
  display: inline-flex;
  ${({ isEmptyPreview }) => isEmptyPreview && css`
    margin-top: var(--cl-space-2);
    margin-left: var(--cl-space-4);
  `}
`;
